var _path, _path2, _path3, _path4, _circle, _path5, _path6, _circle2, _path7, _path8, _circle3, _path9, _path10, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _path21, _path22, _path23, _path24, _path25, _ellipse2, _path26, _path27, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _ellipse10, _path35, _path36, _path37, _path38, _path39, _ellipse11, _path40, _path41, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _rect, _path54, _path55, _path56, _rect2, _path57, _path58, _path59, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreateLiveModalHero = function SvgCreateLiveModalHero(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 647 160",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#create_live_modal_hero_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C5EE2",
    d: "M0 0h647v160H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.539,
    d: "M154.459 35.283h115.219c2.012 0 3.65 1.595 3.65 3.564v63.993c0 1.97-1.638 3.565-3.65 3.565H154.459c-2.012 0-3.65-1.595-3.65-3.565V38.847c0-1.969 1.638-3.564 3.65-3.564Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1F",
    fillRule: "evenodd",
    d: "M43.782 24h237.436c4.292 0 7.782 3.19 7.782 7.112v132.673c0 3.923-3.49 7.113-7.782 7.113H43.782c-4.291 0-7.782-3.19-7.782-7.113V31.112C35.982 27.19 39.473 24 43.782 24",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M195.891 35.279h.818v127.84h-.818z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 212.008,
    cy: 46.949,
    r: 6,
    fill: "url(#create_live_modal_hero_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7480",
    fillRule: "evenodd",
    d: "M224.015 41.177h9.727c1.077 0 1.949.797 1.949 1.774 0 .976-.872 1.774-1.949 1.774h-9.727c-1.077 0-1.949-.798-1.949-1.774 0-.977.872-1.774 1.949-1.774",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M277.257 49.966H223.28c-.534 0-.979-.407-.979-.895s.445-.895.979-.895h53.977c.534 0 .979.407.979.895 0 .504-.445.895-.979.895M277.257 54.245H223.28c-.534 0-.979-.407-.979-.895s.445-.895.979-.895h53.977c.534 0 .979.407.979.895s-.445.895-.979.895",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.008,
    cy: 79.221,
    r: 6,
    fill: "url(#create_live_modal_hero_svg__c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7480",
    fillRule: "evenodd",
    d: "M224.015 73.432h9.727c1.077 0 1.949.797 1.949 1.774 0 .976-.872 1.774-1.949 1.774h-9.727c-1.077 0-1.949-.798-1.949-1.774 0-.977.872-1.774 1.949-1.774",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M277.257 82.238H223.28c-.534 0-.979-.407-.979-.896 0-.488.445-.895.979-.895h53.977c.534 0 .979.407.979.895s-.445.895-.979.895M277.257 86.503H223.28c-.534 0-.979-.407-.979-.895s.445-.895.979-.895h53.977c.534 0 .979.407.979.895s-.445.895-.979.895",
    clipRule: "evenodd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.008,
    cy: 111.477,
    r: 6,
    fill: "url(#create_live_modal_hero_svg__d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7480",
    fillRule: "evenodd",
    d: "M224.015 105.703h9.727c1.077 0 1.949.798 1.949 1.774 0 .977-.872 1.774-1.949 1.774h-9.727c-1.077 0-1.949-.797-1.949-1.774 0-.976.872-1.774 1.949-1.774",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M277.257 114.493H223.28c-.534 0-.979-.407-.979-.895s.445-.895.979-.895h53.977c.534 0 .979.407.979.895 0 .505-.445.895-.979.895M277.257 118.773H223.28c-.534 0-.979-.407-.979-.895s.445-.896.979-.896h53.977c.534 0 .979.407.979.896 0 .488-.445.895-.979.895",
    clipRule: "evenodd"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.008,
    cy: 143.748,
    r: 6,
    fill: "url(#create_live_modal_hero_svg__e)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7480",
    fillRule: "evenodd",
    d: "M224.015 137.975h9.727c1.077 0 1.949.797 1.949 1.774 0 .976-.872 1.774-1.949 1.774h-9.727c-1.077 0-1.949-.798-1.949-1.774 0-.993.872-1.774 1.949-1.774",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M277.257 146.765H223.28c-.534 0-.979-.407-.979-.895s.445-.895.979-.895h53.977c.534 0 .979.406.979.895 0 .488-.445.895-.979.895M277.257 151.03H223.28c-.534 0-.979-.406-.979-.895 0-.488.445-.895.979-.895h53.977c.534 0 .979.407.979.895 0 .505-.445.895-.979.895",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M56.268 52.001h115.218c2.013 0 3.651 1.595 3.651 3.564v63.993c0 1.97-1.638 3.564-3.651 3.564H56.268c-2.013 0-3.65-1.594-3.65-3.564v-64.01c0-1.968 1.637-3.547 3.65-3.547"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#create_live_modal_hero_svg__f)",
    fillRule: "evenodd",
    d: "M56.268 48.437h115.218c2.013 0 3.651 1.595 3.651 3.564v63.993c0 1.969-1.638 3.564-3.651 3.564H56.268c-2.013 0-3.65-1.595-3.65-3.564V52.001c0-1.97 1.637-3.564 3.65-3.564",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7480",
    fillRule: "evenodd",
    d: "M115.78 134.924H53.612c-1.62 0-2.92-1.188-2.92-2.669s1.3-2.669 2.92-2.669h62.168c1.621 0 2.921 1.188 2.921 2.669s-1.3 2.669-2.921 2.669",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M172.236 144.714H51.675c-.534 0-.98-.407-.98-.895s.446-.895.98-.895h120.561c.534 0 .979.407.979.895-.018.488-.445.895-.979.895M172.232 151.679H51.671c-.534 0-.98-.407-.98-.895s.446-.895.98-.895h120.561c.534 0 .979.407.979.895-.018.504-.445.895-.979.895M172.232 157.831H51.671c-.534 0-.98-.407-.98-.895s.446-.895.98-.895h120.561c.534 0 .979.407.979.895-.018.488-.445.895-.979.895",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2F57",
    fillRule: "evenodd",
    d: "M68.313 40.584H53.687c-.381 0-.687-1.113-.687-2.5s.306-2.5.687-2.5h14.626c.381 0 .687 1.113.687 2.5s-.306 2.5-.687 2.5",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M104.707 77.576V98.7c0 2.23 2.725 3.565 4.755 2.328l16.33-9.928c1.763-1.074 1.834-3.401.142-4.557l-16.33-11.197c-2.012-1.4-4.897-.082-4.897 2.23",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#6246BB",
    fillRule: "evenodd",
    d: "m98.45 119.403-.222.29h-17.79l8.22-13.274.018-.034z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E64D0",
    fillRule: "evenodd",
    d: "M139.388 119.692H93.42l-4.758-13.256-.018-.035s10.883-5.452 21.321-8.434l26.848 3.493h.085l.085.017.017.102z",
    clipRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.519,
    cy: 101.702,
    fill: "#6246BB",
    rx: 10.234,
    ry: 5.351,
    transform: "rotate(-13.544 109.519 101.702)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD604B",
    fillRule: "evenodd",
    d: "m102.319 95.02.375 7.873c.034.749.546 1.38 1.263 1.567 2.575.648 8.733 1.466 13.167-3.817.324-.391.444-.92.341-1.414l-2.183-11.025c-.239-1.175-1.586-1.755-2.592-1.073l-9.637 6.407a1.68 1.68 0 0 0-.734 1.482",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C283A",
    fillRule: "evenodd",
    d: "M100.157 76.975s-10.643-2.658-9.637-9.951c1.007-7.31 10.285-13.615 11.769-11.894 1.484 1.704-4.025 4.498-1.211 8.605 2.781 4.072 2.9 8.588-.921 13.24",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A83",
    fillRule: "evenodd",
    d: "m120.759 77.98-6.465 16.239a4.34 4.34 0 0 1-3.837 2.743c-5.97.222-10.098-.681-12.656-1.55-1.962-.682-3.122-2.659-2.798-4.72.29-1.84.648-3.732 1.024-5.606a194 194 0 0 1 1.995-8.742c.444-1.653.819-3.135 1.143-4.31.495-1.807 2.115-3.12 4.008-3.153 7.42-.154 12.691 2.027 15.744 3.8a4.29 4.29 0 0 1 1.842 5.299",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFC7",
    fillRule: "evenodd",
    d: "m100.414 87.222 8.938 1.533a.66.66 0 0 1 .478.954c-.717 1.38-2.542 5.18-6.056 4.516-3.377-.63-4.025-4.822-4.127-6.305a.658.658 0 0 1 .767-.698",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3D54",
    fillRule: "evenodd",
    d: "M116.36 88.358s-1.313-6.032.086-10.48a3.4 3.4 0 0 0-1.604-4.106c-3.087-1.704-8.647-3.834-15.573-2.999 0 0 .41-13.189 9.024-11.962 0 0 2.046.256.682 2.454a1.6 1.6 0 0 0 .017 1.5c.256.46.699.783 1.228.851 4.946.665 14.345 2.505 15.624 7.515 0 0 .136 2.266-.58 3.715a.78.78 0 0 0-.137.664.75.75 0 0 0 .444.511c.648.222 1.33.818 1.364 2.13.052 2.47-6.873 8.418-10.575 10.207",
    clipRule: "evenodd"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.002,
    cy: 86.574,
    fill: "#DD604B",
    rx: 3.818,
    ry: 2.183,
    transform: "rotate(-60 118.002 86.574)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E291D",
    fillRule: "evenodd",
    d: "M119.293 84.933c-.563-.324-1.467.204-2.03 1.193.239-.154.478-.205.666-.085.341.187.358.784.051 1.312-.29.494-.768.75-1.109.613.068.239.154.46.341.562.563.324 1.484-.221 2.047-1.21.597-1.005.597-2.061.034-2.385",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4532",
    fillRule: "evenodd",
    d: "M105.632 81.285c0 2.93-2.559 5.3-5.68 5.3-1.518 0-2.934-.563-3.94-1.5a194 194 0 0 1 1.995-8.742 6 6 0 0 1 1.962-.323c3.104-.017 5.663 2.351 5.663 5.265",
    clipRule: "evenodd"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.336,
    cy: 83.761,
    fill: "#CE4532",
    rx: 5.68,
    ry: 5.282
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.241,
    cy: 80.451,
    fill: "#7CDBDB",
    rx: 5.202,
    ry: 5.197
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.24,
    cy: 80.453,
    fill: "#2F3D54",
    rx: 4.162,
    ry: 4.158
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.675,
    cy: 82.924,
    fill: "#7CDBDB",
    rx: 5.202,
    ry: 5.197
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.677,
    cy: 82.925,
    fill: "#2F3D54",
    rx: 4.162,
    ry: 4.158
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.142,
    cy: 81.668,
    fill: "#F9FAFF",
    rx: 0.912,
    ry: 0.845
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.126,
    cy: 78.93,
    fill: "#F9FAFF",
    rx: 1.087,
    ry: 1.008
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2C1F",
    fillRule: "evenodd",
    d: "m100.414 87.222 8.938 1.533a.66.66 0 0 1 .478.954c-.717 1.38-2.542 3.97-6.056 3.306-3.377-.63-4.025-3.612-4.127-5.095a.658.658 0 0 1 .767-.698",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2C1F",
    fillRule: "evenodd",
    d: "m100.414 87.222 8.938 1.533a.66.66 0 0 1 .478.954c-.717 1.38-2.542 3.97-6.056 3.306-3.377-.63-4.025-3.612-4.127-5.095a.658.658 0 0 1 .767-.698",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFF",
    fillRule: "evenodd",
    d: "m101.402 88.113 6.74 1.104s-.689 1.992-3.71 1.445c-2.907-.52-3.03-2.549-3.03-2.549",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#6246BB",
    fillRule: "evenodd",
    d: "M150.933 119.692h-18.745c.085-11.229 4.212-17.619 4.605-18.25h.017c0-.017.017-.034.017-.034l.034.034c.017.034.068.085.102.12 5.902 6.901 10.661 13.376 13.97 18.13",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CE4532",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.079,
    d: "m106.79 79.36-1.569 6.696"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#6246BB",
    fillRule: "evenodd",
    d: "m409.03 173.141-.543.709H364.91l20.138-32.515.042-.083z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E64D0",
    fillRule: "evenodd",
    d: "M509.305 173.85H396.706l-11.656-32.473-.042-.083s26.656-13.357 52.225-20.661l65.763 8.556h.209l.209.042.042.251z",
    clipRule: "evenodd"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 436.143,
    cy: 129.78,
    fill: "#6246BB",
    rx: 25.067,
    ry: 13.107,
    transform: "rotate(-13.544 436.143 129.78)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD604B",
    fillRule: "evenodd",
    d: "m418.514 113.411.92 19.284a4.15 4.15 0 0 0 3.091 3.84c6.309 1.586 21.392 3.589 32.255-9.35.794-.96 1.086-2.254.836-3.464l-5.348-27.005c-.585-2.88-3.886-4.3-6.351-2.63l-23.606 15.694a4.12 4.12 0 0 0-1.797 3.631",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C283A",
    fillRule: "evenodd",
    d: "M413.208 69.21s-26.071-6.51-23.606-24.375c2.465-17.906 25.194-33.35 28.828-29.134 3.635 4.174-9.86 11.019-2.966 21.078 6.81 9.976 7.103 21.037-2.256 32.431",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A83",
    fillRule: "evenodd",
    d: "m463.682 71.67-15.835 39.778c-1.546 3.924-5.223 6.511-9.401 6.72-14.623.543-24.734-1.669-31.001-3.798-4.805-1.67-7.646-6.511-6.852-11.562.71-4.508 1.588-9.14 2.507-13.732 1.546-7.638 3.301-15.11 4.888-21.412 1.087-4.049 2.006-7.68 2.8-10.56 1.211-4.425 5.18-7.639 9.818-7.722 18.175-.376 31.085 4.967 38.563 9.308 4.513 2.588 6.435 8.139 4.513 12.98",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFC7",
    fillRule: "evenodd",
    d: "m413.846 94.309 21.893 3.756c1.087.167 1.672 1.377 1.17 2.337-1.755 3.381-6.225 12.689-14.832 11.061-8.272-1.544-9.86-11.812-10.111-15.443-.083-1.044.836-1.879 1.88-1.712",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3D54",
    fillRule: "evenodd",
    d: "M452.903 97.093s-3.217-14.776.209-25.67c1.337-3.882-.334-8.14-3.927-10.06-7.563-4.173-21.183-9.39-38.146-7.345 0 0 1.003-32.306 22.102-29.301 0 0 5.014.626 1.671 6.01a3.94 3.94 0 0 0 .042 3.673c.627 1.127 1.713 1.92 3.008 2.087 12.116 1.628 35.138 6.136 38.271 18.407 0 0 .334 5.552-1.42 9.1-.376.459-.46 1.085-.335 1.627.167.585.543 1.044 1.087 1.252 1.587.543 3.258 2.004 3.342 5.218.125 6.052-16.838 20.619-25.904 25.002",
    clipRule: "evenodd"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 456.931,
    cy: 92.723,
    fill: "#DD604B",
    rx: 9.352,
    ry: 5.346,
    transform: "rotate(-60 456.931 92.723)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E291D",
    fillRule: "evenodd",
    d: "M460.085 88.704c-1.379-.793-3.593.5-4.972 2.922.585-.376 1.17-.501 1.63-.21.835.46.877 1.92.125 3.215-.71 1.21-1.88 1.836-2.716 1.502.167.585.376 1.127.836 1.378 1.379.793 3.635-.543 5.014-2.964 1.462-2.462 1.462-5.05.083-5.843",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4532",
    fillRule: "evenodd",
    d: "M426.619 79.77c0 7.179-6.267 12.98-13.913 12.98-3.718 0-7.186-1.377-9.651-3.672 1.546-7.639 3.3-15.11 4.888-21.413 1.462-.5 3.092-.793 4.805-.793 7.604-.041 13.871 5.76 13.871 12.898",
    clipRule: "evenodd"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.05,
    cy: 85.834,
    fill: "#CE4532",
    rx: 13.913,
    ry: 12.939
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.419,
    cy: 77.727,
    fill: "#7CDBDB",
    rx: 12.743,
    ry: 12.73
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.421,
    cy: 77.727,
    fill: "#2F3D54",
    rx: 10.194,
    ry: 10.184
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.88,
    cy: 83.783,
    fill: "#7CDBDB",
    rx: 12.743,
    ry: 12.73
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.882,
    cy: 83.788,
    fill: "#2F3D54",
    rx: 10.194,
    ry: 10.184
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.578,
    cy: 80.704,
    fill: "#F9FAFF",
    rx: 2.234,
    ry: 2.071
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.139,
    cy: 73.998,
    fill: "#F9FAFF",
    rx: 2.662,
    ry: 2.468
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2C1F",
    fillRule: "evenodd",
    d: "m413.846 94.309 21.893 3.756c1.087.167 1.672 1.377 1.17 2.337-1.755 3.381-6.225 9.726-14.832 8.098-8.272-1.545-9.86-8.849-10.111-12.48-.083-1.044.836-1.879 1.88-1.712",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2C1F",
    fillRule: "evenodd",
    d: "m413.846 94.309 21.893 3.756c1.087.167 1.672 1.377 1.17 2.337-1.755 3.381-6.225 9.726-14.832 8.098-8.272-1.545-9.86-8.849-10.111-12.48-.083-1.044.836-1.879 1.88-1.712",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFF",
    fillRule: "evenodd",
    d: "m416.258 96.496 16.509 2.704s-1.688 4.879-9.087 3.538c-7.122-1.275-7.422-6.242-7.422-6.242",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#6246BB",
    fillRule: "evenodd",
    d: "M537.585 173.849h-45.917c.209-27.507 10.32-43.159 11.281-44.703h.041c0-.042.042-.084.042-.084l.084.084c.042.083.167.209.251.292 14.456 16.904 26.112 32.765 34.218 44.411",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M594.275 85.701c-6.516-2.021-10.156-8.955-8.13-15.487 2.026-6.531 8.951-10.188 15.468-8.166l37.478 11.625c4.784 1.484 8.018 5.616 8.597 10.293l7.767 2.41a5 5 0 0 1 .434.134l3.253 1.01a5.093 5.093 0 0 1 3.348 6.376 5.1 5.1 0 0 1-5.66 3.529l-2.856 9.209 1.993.618a3 3 0 0 1 1.976 3.754l-2.157 6.955-1.461-.453 9.7 3.009a3 3 0 0 1 1.977 3.754l-.417 1.343 23.508 7.292a3 3 0 0 1 1.977 3.754l-15.629 50.385a3 3 0 0 1-3.754 1.976l-9.648-2.992-.069-.021-81.719-25.349a3 3 0 0 1-1.976-3.754l.12-.389-6.282-1.948-1.988-.617-.015-.005-7.509-2.329-.023-.007-7.409-2.298c-4.104-1.274-6.078-12.974-2.207-25.451 3.87-12.477 12.119-21.007 16.223-19.734l7.432 2.306h-.001l7.525 2.334 1.988.616 1.784.554 1.492-4.812a3 3 0 0 1 3.754-1.976l23.863 7.402.012.003-1.42-.44v-.002l-14.024-4.35a1.92 1.92 0 0 1 2.403-1.265l12.232 3.794a3 3 0 0 1 3.56-1.497l8.239 2.556 2.158-6.955a3 3 0 0 1 3.754-1.977l9.705 3.011.011.003 1.993.618 2.841-9.16-3.819-1.184c-3.125 3.528-8.129 5.105-12.913 3.62z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "M549.752 144.553c-4.105-1.273-6.078-12.974-2.208-25.451s12.119-21.007 16.224-19.733l7.431 2.305-14.016 45.184z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M557.183 146.857c-5.254-1.63-6.375-13.066-2.505-25.543 3.87-12.478 11.267-21.271 16.52-19.642l9.513 2.951-14.016 45.184z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E33",
    d: "M564.71 149.19c-4.813-1.492-5.576-12.817-1.706-25.295 3.87-12.477 10.909-21.381 15.721-19.889l9.123 2.83-14.016 45.184z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1F",
    fillRule: "evenodd",
    d: "M580.73 65.455c-2.026 6.532 1.614 13.465 8.13 15.486l37.478 11.626c6.516 2.021 13.441-1.635 15.468-8.167s-1.614-13.465-8.131-15.487l-37.478-11.625c-6.516-2.021-13.441 1.635-15.467 8.167",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M650.258 81.677a4.365 4.365 0 0 0-5.459 2.882l-6.31 20.342a4.365 4.365 0 0 0 2.869 5.466 4.365 4.365 0 0 0 5.459-2.882l6.31-20.342a4.366 4.366 0 0 0-2.869-5.466",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M629.31 80.526a5.09 5.09 0 0 0 3.347 6.377l18.046 5.597a5.09 5.09 0 0 0 6.368-3.362 5.09 5.09 0 0 0-3.347-6.377l-18.045-5.598a5.09 5.09 0 0 0-6.369 3.363",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "M650.869 116.498a3 3 0 0 0-1.977-3.754l-34.523-10.709a3 3 0 0 0-3.754 1.976l-.417 1.344 40.254 12.486zM642.81 103.233a3 3 0 0 0-1.976-3.755l-12.315-3.82a3 3 0 0 0-3.754 1.977l-2.157 6.955 18.045 5.597z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#create_live_modal_hero_svg__g)",
    d: "M675.935 128.887a3 3 0 0 0-1.976-3.754l-86.218-26.744a3 3 0 0 0-3.754 1.976l-2.369 7.639a30 30 0 0 0-1.255 11.233l.095 1.218a30 30 0 0 1-1.255 11.232l-6.346 20.458a3 3 0 0 0 1.977 3.755l81.718 25.348a3 3 0 0 0 3.754-1.976z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81.386,
    height: 58.753,
    fill: "#464B52",
    rx: 3,
    transform: "scale(-1 1)rotate(-17.234 82.488 2329.812)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M660.584 119.512a3 3 0 0 0-1.977-3.754l-34.523-10.709a3 3 0 0 0-3.755 1.976l-.416 1.343 40.254 12.487z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    d: "M652.525 106.246a3 3 0 0 0-1.976-3.754l-12.315-3.82a3 3 0 0 0-3.754 1.977l-2.157 6.955 18.045 5.597z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M612.822 106.166a1.92 1.92 0 0 0-1.266-2.403l-12.978-4.026a1.92 1.92 0 0 0-2.403 1.265z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55.227,
    height: 49.94,
    fill: "#32363B",
    rx: 1,
    transform: "scale(-1 1)rotate(-17.234 86.135 2255.671)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1F",
    d: "m662.816 127.896-50.441-15.646-13.88 44.745 50.441 15.647z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6342C",
    d: "m592.602 108.312-10.107-3.135-.554 1.784 10.107 3.135z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "m580.628 150.219-6.538-2.029 3.516-18.336c.172-.896.249-1.808.23-2.721l-.089-4.228a14 14 0 0 1 .626-4.441l3.568-11.504 10.107 3.135c-1.053 3.396-1.013 6.647-.581 9.231.524 3.14.935 6.437-.008 9.477l-5.825 18.78a4 4 0 0 1-5.006 2.636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_modal_hero_svg__b",
    x1: 206.009,
    x2: 218.007,
    y1: 52.947,
    y2: 52.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_modal_hero_svg__c",
    x1: 206.009,
    x2: 218.007,
    y1: 85.218,
    y2: 85.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#5981E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_modal_hero_svg__d",
    x1: 206.009,
    x2: 218.007,
    y1: 117.474,
    y2: 117.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C87CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#EC9B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_modal_hero_svg__e",
    x1: 206.009,
    x2: 218.007,
    y1: 149.745,
    y2: 149.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#EC4E22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_modal_hero_svg__f",
    x1: 52.625,
    x2: 175.132,
    y1: 119.543,
    y2: 119.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#EC4E22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_modal_hero_svg__g",
    x1: 630.85,
    x2: 613.444,
    y1: 111.761,
    y2: 167.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32363B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "create_live_modal_hero_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h647v160H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreateLiveModalHero);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "create_live_modal_hero.svg";